module.exports = __webpack_public_path__ + "img/top_300.7a854eed.png";